import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import Loader from 'react-loader-spinner';

import { dispatch } from 'store';
import { RootState } from 'types';
import { routes } from 'routes';
import { getDashboardInfo } from 'modules/dashboard/actions';
import { getStripePrices, setCurrentStripePrice, setBillingType, setTemporary } from 'modules/auth/actions';
import { setNotification } from 'modules/app/actions';
import { getCurrencySymbol, t } from 'utils';

import { CardForm } from './CardForm';
import { Button, LanguagesSelect } from 'views/components';

import styles from './Plan.module.css';
import logo from 'assets/images/logo.svg';
import { updateSubscription } from 'modules/subscription/actions';
import { STRIPE_PK } from 'config';
import { history } from 'services/history';
import texts from './texts';
import { Api } from 'services/api';
import { useLocation } from 'react-router-dom';

export const Plan: FC = () => {
  // store
  const [init, setInit] = useState(false);
  const { currentCountry } = useSelector((state: RootState) => state.app);
  const { currencyType } = useSelector((state: RootState) => state.user);
  const { registerData, stripePrices, token } = useSelector((state: RootState) => state.auth);
  const { errors, loading } = useSelector((state: RootState) => state.subscription);
  const { plan } = useSelector((state: RootState) => state.dashboard);
  const { notification } = useSelector((state: RootState) => state.app);
  const apiToken = Api.getAxios().defaults.headers.Authorization ? true : false;
  let location: any = useLocation();

  const isTrial = plan.price === 'Trial' && plan.is_active;
  const ppcPriceValue = {
    billing_type: "ppc",
    nickname: "1 camera",
    number_of_machines: 1,
    price: 50
  };
  const stripePricesMonthly: any = [];
  const stripePricesAnnual: any = [];
  const stripePricesPpc: any = [];
  const stripePromise: any = STRIPE_PK && loadStripe(STRIPE_PK);

  stripePrices.map(el => {
    if (el.billing_type === 'monthly') {
      if(location && location.state && location.state.totalCameras && location.state.totalCameras === '1 camera') {
        stripePricesMonthly.push(el);
      } else {
        stripePricesMonthly.push(el);
      }

    } else if (el.billing_type === 'annually') {
      stripePricesAnnual.push(el);
    } else {
      stripePricesPpc.push(el);
    }
  });

  const billingTypeAnnual = registerData.billingType === 'Annual';
  const billingTypeMonthly= registerData.billingType === 'Monthly';

  useEffect(() => {
    !apiToken && Api.setAuthToken(token);
  }, [apiToken]);

  useEffect(() => {
    if (notification.status && notification.type === 'success') {
      NotificationManager.success(notification.text);
      dispatch(setNotification(false));
      setTimeout(() => {
        dispatch(getDashboardInfo.request());
        history.push('/dashboard');
      }, 1000);
    }
  }, [notification]);

  useEffect(() => {
    dispatch(setTemporary(Boolean(location.state && location.state.isFiveCameras)));
  }, [location.state]);

  useEffect(() => {
    if (currencyType && apiToken) {
      dispatch(getDashboardInfo.request());
      dispatch(getStripePrices.request());
    }
  }, [currencyType, apiToken]);

  // useEffect(() => {
  //   if (!registerData.currentStripePrice && stripePrices.length > 0) {
  //     dispatch(setCurrentStripePrice(stripePricesMonthly[0]));
  //   } else {
  //     dispatch(setCurrentStripePrice(registerData.currentStripePrice));
  //   }
  // }, [stripePrices, registerData]);

  // useEffect(() => {
  //   if(location.state && location.state.type) {
  //     dispatch(setBillingType(location.state.type));
  //   }
  // }, [location.state]);

  useEffect(() => {
    if(
      location.state &&
      location.state.totalCameras && !init
    ) {
      let item;
      if (billingTypeAnnual) {
        item = stripePricesAnnual.find((el: any) => el.nickname === location.state.totalCameras) || null;
      } else if(billingTypeMonthly) {
        item = stripePricesMonthly.find((el: any) => el.nickname === location.state.totalCameras) || null;
      }  else {
        item = {
          ...ppcPriceValue,
          nickname: location.state.totalCameras,
          number_of_machines: location.state.totalCameras[0]
        }
      }
      if(location.state && location.state.isFiveCameras) {
        item = stripePricesMonthly[0];
      }
      
      dispatch(setCurrentStripePrice(item));
    }
    // if(location.state && location.state.type) {
    //   dispatch(setBillingType(location.state.type));
    // }
    setInit(true)
  }, [location.state, registerData.currentStripePrice, init]);

  useEffect(() => {
      let item;
      if (billingTypeAnnual && registerData.currentStripePrice && registerData.currentStripePrice.nickname) {
        item = stripePricesAnnual.find((el: any) => el.nickname === registerData.currentStripePrice.nickname) || null;
      } else if(billingTypeMonthly && registerData.currentStripePrice && registerData.currentStripePrice.nickname) {
        item = stripePricesMonthly.find((el: any) => el.nickname === registerData.currentStripePrice.nickname) || null;
      } else {
        item = {
          ...ppcPriceValue,
        }
      }
      dispatch(setCurrentStripePrice(item));
  }, [location, stripePrices]);

  const handleInputChange = (event: any) => {
    const { value } = event.target;
    let item;
    if (billingTypeAnnual) {
      item = stripePricesAnnual.find((el: any) => el.nickname === value) || null;     
    } else if(billingTypeMonthly) {
      item = stripePricesMonthly.find((el: any) => el.nickname === value) || null;
    } else {
      item = {
        ...ppcPriceValue,
        nickname: value,
        number_of_machines: value[0]
      }
    }
    dispatch(setCurrentStripePrice(item));
  };

  const renderError = () => {
    for (let key in errors) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
    }
  };
  
const showAnnual = () => {
  switch(currentCountry) {
    case 'EU': 
    return null;
    case 'UK': 
    return null;
    case 'NL': 
    return null;
    case 'DE': 
    return null;
    case 'US': 
    if(location.state && location.state.plan) {
      return true
    } 
    return null;
    case 'AU': 
    if(location.state && location.state.plan) {
      return true
    } 
    return null;
    default: 
    return true;
  }
}
  return (
    <div className={styles.wrap}>
      {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}> */}
      <div className={styles.top}>
        <a href="/dashboard" style={{ margin: '36px 0 20px 0', display: 'inline-block' }}>
          <img src={logo} alt="logo" />
        </a>
        <LanguagesSelect />
      </div>
      <div style={{ display: 'flex', marginBottom: '40px' }}>
        <div>
          {renderError()}
          <Link className={styles.link} to={routes.licence}>
            {t(texts.plan.backToLicence)}
          </Link>
          {currencyType && apiToken ? (
            <>
              <h1>{t(texts.plan.title)}</h1>
              <div className={styles.order}>
                <div style={{ width: '380px', marginBottom: '20px' }}>
                  <p style={{ fontSize: '12px' }}>{t(texts.plan.planType)}</p>
                 {showAnnual() && (
                    <label style={{ marginRight: '10px' }}>
                    <input
                      style={{ width: '10px' }}
                      type="radio"
                      checked={registerData.billingType === 'Annual'}
                      value="Annual"
                      onClick={() => {
                        dispatch(setCurrentStripePrice(stripePricesAnnual[(location.state && location.state.disableOneCamera) ? 1 : 0]));
                        dispatch(setBillingType('Annual'));
                      }}
                    />
                    {t(texts.plan.annual)}
                  </label>
                 )}
                  <label style={{ marginRight: '10px' }}>
                    <input
                      style={{ width: '10px' }}
                      type="radio"
                      checked={registerData.billingType === 'Monthly'}
                      value="Monthly"
                      onClick={() => {
                        dispatch(setCurrentStripePrice(stripePricesMonthly[(location.state && location.state.disableOneCamera) ? 1 : 0]));
                        dispatch(setBillingType('Monthly'));
                      }}
                    />
                    {t(texts.plan.monthly)}
                  </label>
                  {/* {currentCountry === 'AU' && (
                    <label>
                      <input
                        style={{ width: '10px' }}
                        type="radio"
                        checked={registerData.billingType === 'ppc'}
                        value="ppc"
                        onClick={() => {
                          dispatch(setCurrentStripePrice(ppcPriceValue));
                          dispatch(setBillingType('ppc'));
                        }}
                      />
                      {t(texts.plan.payPerClick)}
                    </label>
                  )} */}
                </div>
                <select className={styles.main} onChange={handleInputChange}>
                  {billingTypeAnnual
                    ? stripePricesAnnual.map((el: any) => (
                        <option
                          key={el.nickname}
                          value={el.nickname}
                          disabled={
                            el.nickname === '0 cameras' ||
                            (location.state && location.state.totalCameras === '1 camera') ||
                            (location.state && location.state.totalCameras === '2 cameras' && el.nickname === '0 camera') ||
                            (location.state && location.state.totalCameras === '2 cameras' && el.nickname === '1 camera') ||
                            (location.state && location.state.totalCameras === '5 cameras' && el.nickname === '0 camera') ||
                            (location.state && location.state.totalCameras === '5 cameras' && el.nickname === '1 camera' &&
                              location.state && location.state.type !== 'ppc'
                            )
                          }
                          selected={
                            (registerData?.currentStripePrice?.nickname === el.nickname)
                          }
                        >
                          {el.nickname}
                        </option>
                      ))
                    : stripePricesMonthly.map((el: any, i: number) => (
                        <option
                          disabled={
                            el.nickname === '0 cameras' ||
                            (location.state && location.state.totalCameras === '1 camera') ||
                            (location.state && location.state.totalCameras === '2 cameras' && el.nickname === '0 camera') ||
                            (location.state && location.state.totalCameras === '2 cameras' && el.nickname === '1 camera') ||
                            (location.state && location.state.totalCameras === '5 cameras' && el.nickname === '0 camera') ||
                            (location.state && location.state.totalCameras === '5 cameras' && el.nickname === '1 camera' &&
                              location.state && location.state.type !== 'ppc' && location.state.isFiveCameras !== 'true'
                            )
                          }
                          key={el.nickname}
                          value={el.nickname}
                          selected={registerData?.currentStripePrice?.nickname === el.nickname}
                        >
                          {el.nickname}
                        </option>
                      ))}
                </select>
                {isTrial && (
                  <p style={{ fontSize: '22px', fontWeight: 'bold', fontStyle: 'italic' }}>
                    {t(texts.plan.freeTrial)}
                  </p>
                )}
                <p>
                  {' '}
                  <span style={{ fontSize: '30px', fontStyle: 'italic' }}>
                    {' '}
                    {stripePrices[0] && stripePrices[0]?.currency?.toUpperCase()}{' '}
                    {stripePrices[0] &&
                      currencyType &&
                      getCurrencySymbol(currencyType, stripePrices[0]?.currency).icon}
                    {

(registerData.currentStripePrice && registerData.currentStripePrice?.price && registerData.currentStripePrice?.billing_type === 'ppc'  ?
registerData.currentStripePrice && registerData.currentStripePrice?.price * registerData.currentStripePrice?.number_of_machines :
registerData.currentStripePrice && registerData.currentStripePrice?.price
) ||
(ppcPriceValue.price)
                    }
                  </span>{' '}
                  {billingTypeAnnual ? '/year' : '/month'}
                </p>

                {billingTypeAnnual ? (
                  <p style={{ fontStyle: 'italic' }}>*{t(texts.plan.eachYear)} </p>
                ) : (
                  <p style={{ fontStyle: 'italic' }}>*{t(texts.plan.eachMonth)} </p>
                )}

                {isTrial ? (
                  <Button
                    title={t(texts.plan.updateCurrentPlan)}
                    onClick={() => dispatch(updateSubscription.request())}
                    loading={loading}
                  />
                ) : (
                  plan.price &&
                  plan.price !== '' &&
                  (loading ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Loader type="ThreeDots" color="#000" height={30} width={50} />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                      }}
                    >
                      <Elements stripe={stripePromise}>
                        <CardForm isActivePlan={plan.is_active} />
                      </Elements>
                    </div>
                  ))
                )}
              </div>
            </>
          ) : (
            <>
              <p style={{ fontStyle: 'italic' }}>{t(texts.plan.loading)}...</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
